import { useQuery } from "@tanstack/react-query";
import { getSystemCategoryMenu } from "src/api/categoryMenu";
export const CATEGORY_QUERY_KEYS = {
    CATEGORY_MENU: "systemCategoryMenu",
    CATEGORY_PRODUCTS: "categoryProducts"
};
/**
 * 시스템 카테고리 과목 매핑
 */ export const SUBJECT_PARENT_ID = {
    영어: 10,
    국어: 11,
    수학: 12,
    과학: 13,
    사회: 14
};
/**
 * parentId로 과목명 찾기
 */ export const getSubjectNameByParentId = (parentId)=>{
    var _Object_entries_find;
    return (_Object_entries_find = Object.entries(SUBJECT_PARENT_ID).find((param)=>{
        let [_, id] = param;
        return id === parentId;
    })) === null || _Object_entries_find === void 0 ? void 0 : _Object_entries_find[0];
};
/**
 * 시스템 카테고리 메뉴를 조회하는 훅
 * /menu-categories API 사용 (재귀적 트리 구조)
 * @param parentId - 과목 ID
 */ export const useCategoryMenu = (parentId)=>{
    return useQuery({
        queryKey: [
            CATEGORY_QUERY_KEYS.CATEGORY_MENU,
            parentId
        ],
        queryFn: ()=>getSystemCategoryMenu(parentId),
        staleTime: 1000 * 60 * 5,
        enabled: !!parentId
    });
};
